import { Flex } from 'antd';
/**
 * 
 * @returns 
 */
export const BaseElementVLabelBox = ({ label, children }) => {
  return (
    <Flex vertical={true}>
      <span className='divider-small' style={{ padding: '0.3rem', fontSize: '1rem' }}>{label}</span>
      {children} 
    </Flex> 
  );
};
